module.exports = __webpack_public_path__ + "img/tier1-visual-f.bf773f7.svg";